import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import checkValue from '../../../../../../../../utils/values';
import FiduciaPdf from '../../../DownloadPdf/components/FiduciaPdfComponents';

function PdfGlobalTedIncome() {
  const incomeFaresState = useSelector(
    (reducer: IReducer) => reducer.incomeFares
  );

  return (
    <>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Tarifas de Cartão recebidas:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.card.received).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Tarifas de Cartão repassadas:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.card.passedOn).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
      <FiduciaPdf.ContainerLabelValues>
        <FiduciaPdf.Label>Receita obtida com Cartão:</FiduciaPdf.Label>
        <FiduciaPdf.Values isActive>
          {checkValue(incomeFaresState.card.income).toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          })}
        </FiduciaPdf.Values>
      </FiduciaPdf.ContainerLabelValues>
    </>
  );
}

export default PdfGlobalTedIncome;
